(() => {
  const originalTexts = new Map();

  const contentMap = {
    'Commercial': '<p>The commercial configuration pairs precision with reliability. One side runs the full 32°F to 107°F range. The other delivers consistent cooling to 37°F, engineered for constant use. Both sides are fully interchangeable. Choose which side runs which temperature, and change it whenever you want. For simultaneous contrast, 37°F cold pairs with 107°F heat.</p>',
    'Residential': '<p><strong>Both sides share the same ChillX engine. </strong>Either can run cold to 32°F with active ice-making, or heat to 107°F. Want both cold simultaneously? They can even form ice. The Contrast Edition adapts to how you want to practice, not the other way around.</p>'
  };

  document.addEventListener('click', function(event) {
    const btn = event.target.closest('.tabbed-content__nav-item');
    if (!btn) return;

    const wrapper = btn.closest('.section-content-wrapper');
    if (!wrapper) return;

    const targetBlock = wrapper.querySelector('.text-block:nth-child(3)');
    if (!targetBlock) return;

    if (!originalTexts.has(targetBlock)) {
      originalTexts.set(targetBlock, targetBlock.innerHTML);
    }

    const btnText = btn.textContent.trim();

    if (btnText === 'Commercial') {
      targetBlock.innerHTML = contentMap['Commercial'];
    } else if (btnText === 'Residential') {
      targetBlock.innerHTML = contentMap['Residential'] || originalTexts.get(targetBlock);
    }
  });
})();